// import React, { useState } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';
// import userState from '../../../shared/mobx/user-state';
// import settingsState from '../../../shared/mobx/settings-state';

// const ContactUsSection: React.FC = () => {
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });

//   const [errors, setErrors] = useState({
//     full_name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });

//   const [isLoading, setIsLoading] = useState(false);
//   const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
//   const [recaptchaError, setRecaptchaError] = useState<string>("");
//   const [recaptchaSiteKey, setRecaptchaSiteKey] = useState<string | null>(null);
//   const [recaptchaLoading, setRecaptchaLoading] = useState<boolean>(true);

//   // Fetch the site key from settingsState on mount
//   React.useEffect(() => {
//     let mounted = true;
//     const fetchSiteKey = async () => {
//       setRecaptchaLoading(true);
//       try {
//         const clientSettings = await settingsState.getClientSettings();
//         if (mounted) {
//           setRecaptchaSiteKey(clientSettings?.recaptchaSiteKey || clientSettings?.recaptcha_config?.site_key || '');
//         }
//       } catch (e) {
//         if (mounted) setRecaptchaSiteKey('');
//       } finally {
//         if (mounted) setRecaptchaLoading(false);
//       }
//     };
//     fetchSiteKey();
//     return () => { mounted = false; };
//   }, []);

//   const validateEmail = (email: string) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });

//     setErrors({
//       ...errors,
//       [name]: ''
//     });
//   };

//   const handleRecaptchaChange = (token: string | null) => {
//     setRecaptchaToken(token);
//     setRecaptchaError("");
//   };

//   const validateForm = () => {
//     let valid = true;
//     let newErrors = { full_name: '', email: '', subject: '', message: '' };

//     if (!formData.full_name) {
//       newErrors.full_name = 'Full name is required';
//       valid = false;
//     }

//     if (!formData.email) {
//       newErrors.email = 'Email is required';
//       valid = false;
//     } else if (!validateEmail(formData.email)) {
//       newErrors.email = 'Email is not valid';
//       valid = false;
//     }

//     if (!formData.message) {
//       newErrors.message = 'Message is required';
//       valid = false;
//     }

//     if (!recaptchaToken) {
//       setRecaptchaError("Please verify that you are not a robot.");
//       valid = false;
//     }

//     setErrors(newErrors);
//     return valid;
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (validateForm()) {
//       setIsLoading(true);
//       try {

//       // Use the token from the reCAPTCHA widget already stored in state
//       const token = recaptchaToken;

//       // Send token with form
//       const status = await userState.contactUs({ ...formData, token }); 
//         if (status) {
//           setFormData({
//             full_name: '',
//             email: '',
//             subject: '',
//             message: ''
//           });
//           setRecaptchaToken(null);
//         }
//       } catch (error) {
//         console.error('Error submitting form:', error);
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   return (
//     <div className="reach-wrap" id="contact">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-12">
//             <h2 className='reach'>Reach Out</h2>
//             <p>
//               We’re happy to help or answer any questions about Webs2pdf. Please 
//               provide your information and we will respond as soon as possible.
//             </p>
//           </div>
//         </div>
//         <div className="row">
//           <div className="contact-form">
//             <form onSubmit={handleSubmit}>
//               <div className="form-row">
//                 <div className="form-group">
//                   <input
//                     type="text"
//                     id="full_name"
//                     name="full_name"
//                     placeholder="Name"
//                     value={formData.full_name}
//                     onChange={handleInputChange}
//                     required
//                     disabled={isLoading}
//                   />
//                   {errors.full_name && <span className="error text-danger">{errors.full_name}</span>}
//                 </div>
//                 <div className="form-group">
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     placeholder="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                     disabled={isLoading}
//                   />
//                   {errors.email && <span className="error text-danger">{errors.email}</span>}
//                 </div>
//               </div>
//               <div className="form-group">
//                 <input
//                   type="text"
//                   id="subject"
//                   name="subject"
//                   placeholder="subject"
//                   value={formData.subject}
//                   onChange={handleInputChange}
//                   required
//                   disabled={isLoading}
//                 />
//               </div>
//               <div className="form-group">
//                 <textarea
//                   id="message"
//                   placeholder="message"
//                   name="message"
//                   rows={5}
//                   value={formData.message}
//                   onChange={handleInputChange}
//                   required
//                   disabled={isLoading}
//                 ></textarea>
//                 {errors.message && <span className="error text-danger">{errors.message}</span>}
//               </div>
//               <div className="form-group">
//                 {recaptchaLoading ? (
//                   <div>Loading reCAPTCHA...</div>
//                 ) : recaptchaSiteKey ? (
//                   <ReCAPTCHA
//                     sitekey={recaptchaSiteKey}
//                     onChange={handleRecaptchaChange}
//                     theme="light"
//                   />
//                 ) : (
//                   <span className="error text-danger">reCAPTCHA could not be loaded</span>
//                 )}
//                 {recaptchaError && <span className="error text-danger">{recaptchaError}</span>}
//               </div>
//               <button type="submit" className="btn-submit" disabled={isLoading}>
//                 {isLoading ? <span><i className="fa fa-spinner fa-spin" style={{ fontSize: '1rem' }}></i> Sending...</span> : "Send Message"}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUsSection;

// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import userState from '../../../shared/mobx/user-state';
import settingsState from '../../../shared/mobx/settings-state';

const ContactUsForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    full_name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState('');

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = { full_name: '', email: '', subject: '', message: '' };

    // Name validation
    if (!formData.full_name) {
      newErrors.full_name = 'Full name is required';
      valid = false;
    } else if (formData.full_name.length > 50) {
      newErrors.full_name = 'Name must be 50 characters or less';
      valid = false;
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is required';
      valid = false;
    } else if (formData.email.length > 100) {
      newErrors.email = 'Email must be 100 characters or less';
      valid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Email is not valid';
      valid = false;
    }

    // Subject validation
    if (!formData.subject) {
      newErrors.subject = 'Subject is required';
      valid = false;
    } else if (formData.subject.length > 100) {
      newErrors.subject = 'Subject must be 100 characters or less';
      valid = false;
    }

    // Message validation
    if (!formData.message) {
      newErrors.message = 'Message is required';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!executeRecaptcha) {
      console.error('Recaptcha not loaded yet');
      setRecaptchaError('Recaptcha not ready, please refresh and try again.');
      return;
    }

    setIsLoading(true);
    try {
      // Get v3 token
      const token = await executeRecaptcha('contact_us_form');
      if (!token) {
        setRecaptchaError('Recaptcha failed. Please try again.');
        setIsLoading(false);
        return;
      }

      const status = await userState.contactUs({ ...formData, token });

      if (status) {
        setFormData({ full_name: '', email: '', subject: '', message: '' });
        setRecaptchaError('');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <input
            type="text"
            id="full_name"
            name="full_name"
            placeholder="Name"
            value={formData.full_name}
            onChange={handleInputChange}
            required
            disabled={isLoading}
            maxLength={50}  
          />
          {errors.full_name && <span className="error text-danger">{errors.full_name}</span>}
        </div>
        <div className="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            disabled={isLoading}
            maxLength={100}
          />
          {errors.email && <span className="error text-danger">{errors.email}</span>}
        </div>
      </div>
      <div className="form-group">
        <input
          type="text"
          id="subject"
          name="subject"
          placeholder="subject"
          value={formData.subject}
          onChange={handleInputChange}
          required
          disabled={isLoading}
          maxLength={100}
        />
        {errors.subject && <span className="error text-danger">{errors.subject}</span>}
      </div>
      <div className="form-group">
        <textarea
          id="message"
          placeholder="message"
          name="message"
          rows={5}
          value={formData.message}
          onChange={handleInputChange}
          required
          disabled={isLoading}
        ></textarea>
        {errors.message && <span className="error text-danger">{errors.message}</span>}
      </div>

      {recaptchaError && <span className="error text-danger">{recaptchaError}</span>}

      <button type="submit" className="btn-submit" disabled={isLoading}>
        {isLoading ? <span><i className="fa fa-spinner fa-spin" style={{ fontSize: '1rem' }}></i> Sending...</span> : "Send Message"}
      </button>
    </form>
  );
};

const ContactUsSection = () => {
  const [siteKey, setSiteKey] = useState('');

  useEffect(() => {
    const fetchKey = async () => {
      const clientSettings = await settingsState.getClientSettings();
      setSiteKey(clientSettings?.recaptchaSiteKey || clientSettings?.recaptcha_config?.site_key || '');
    };
    fetchKey();
  }, []);

  if (!siteKey) return null;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head'
      }}
      clasName="grecaptcha-badge"
    >
      <div className="reach-wrap" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className='reach'>Reach Out</h2>
              <p>
                Have questions about converting websites to PDF or need help choosing the right plan? Our team is here to help.
              </p>
              <p>
                Whether you're converting a single webpage, managing bulk website-to-PDF conversions, or looking for advanced features, we'll help you find the best solution. Simply fill out the form below, and we'll get back to you as soon as possible.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="contact-form">
              <ContactUsForm />
            </div>
          </div>
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default ContactUsSection;
